import React from 'react';
import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import { LocalizedTableCell as TableCell } from '../i18n/LocalizedMui';

export type KpTableRow = { key: string; cells: React.ReactNode[]; highlight?: boolean };

export default function KpDataTable({ headers, rows, label, firstColumnWidth = 110 }: {
  headers: string[]; rows: KpTableRow[]; label: string; firstColumnWidth?: number;
}) {
  return <TableContainer sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, mb: 2 }}>
    <Table size="small" aria-label={label} sx={{ minWidth: headers.length * 125,
      '& th, & td': { borderRight: '1px solid', borderColor: 'divider', py: 1.25, verticalAlign: 'top' },
      '& th:last-child, & td:last-child': { borderRight: 0 },
      '& tbody tr:nth-of-type(even)': { bgcolor: 'action.hover' },
      '& tr > :first-child': { position: 'sticky', left: 0, zIndex: 1,
        bgcolor: 'background.paper', minWidth: firstColumnWidth, width: firstColumnWidth },
      '& thead th': { bgcolor: 'action.selected', fontWeight: 700 },
      '& thead th:first-of-type': { bgcolor: 'background.paper', zIndex: 2 },
    }}>
      <TableHead><TableRow>{headers.map((header, index) => <TableCell key={index} scope="col">{header}</TableCell>)}</TableRow></TableHead>
      <TableBody>{rows.map(row => <TableRow key={row.key} sx={row.highlight ? {
        '& td': { bgcolor: 'action.selected' }, '& th': { bgcolor: 'background.paper', color: 'primary.main' },
      } : undefined}>{row.cells.map((cell, index) => <TableCell key={index} component={index === 0 ? 'th' : 'td'}
        scope={index === 0 ? 'row' : undefined} sx={{ fontWeight: index === 0 ? 700 : 400 }}>{cell}</TableCell>)}</TableRow>)}</TableBody>
    </Table>
  </TableContainer>;
}
